/**
 * Hides the Shop Pay Installments message when the selected variant is
 * under the CRO-configured threshold, and keeps it in sync on variant
 * change without a page reload.
 */
(function () {
  function toggleInstallment(sectionId, variant) {
    var el = document.getElementById("Installment-" + sectionId);
    if (!el || !variant) return;
    el.classList.toggle("hidden", variant.price < 3500);
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (typeof webvista === "undefined" || !webvista.subscribe) return;

    webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      toggleInstallment(event.data.sectionId, event.data.variant);
    });
  });
})();
